import { useSelector } from 'react-redux';

import {
  flashMessageInitialState,
  type FlashMessageState,
} from '../FlashMessages/FlashMessages.interfaces';
import type { SpartacuxShoppingCartState } from '../ShoppingCartState';

export const useFlashMessage = () =>
  useSelector<SpartacuxShoppingCartState, FlashMessageState>(
    (state) => state.shoppingCart?.flashMessage || flashMessageInitialState,
  );
